import {Pipe, PipeTransform} from '@angular/core';
import {ScanStatusEnum} from '../../Shared/Enum/scan-status.enum';

@Pipe({
  name: 'scanStatusLabel',
  standalone: false,
})
export class ScanStatusLabelPipe implements PipeTransform {

  transform(status: ScanStatusEnum): string {

    const statusMap: Record<ScanStatusEnum, string> = {
      [ScanStatusEnum.pending]: 'Procesando',
      [ScanStatusEnum.notProcessed]: 'Procesando',
      [ScanStatusEnum.processed]: 'Por revisar',
      [ScanStatusEnum.rejected]: 'Fallido',
      [ScanStatusEnum.error]: 'Fallido',
      [ScanStatusEnum.incomplete]: 'Fallido',
      [ScanStatusEnum.duplicated]: 'Duplicado',
    };

    return statusMap[status] ?? status;

  }

}
